import React from 'react';
import { routes } from 'utils/routing';
import GoogleIcon from 'components/svg/google-24px.svg';
import OutlookIcon from 'components/svg/outlook-24px.svg';
import CalendarAppleIcon from 'components/svg/calendar-apple-24px.svg';

const dateGoogle = (param) => param.replace(/\.\d+Z$/g, 'Z').replace(/[^\w\d]/g, '');

const path = 'https://www.google.com/calendar/event';

const addToCalendarData = {
  google: {
    icon: <GoogleIcon />,
    route: (event) => {
      const { title, start_at, end_at, description, address, timezone, livestream_link, has_location } = event;
      const { address_name, address1, address2, city, state } = address || {};

      const fullAddress = [address_name, address1, address2, city, state].filter(Boolean).join(', ');
      const startDate = start_at ? dateGoogle(start_at) : '';
      const endDate = end_at ? dateGoogle(end_at) : '';
      const location = has_location ? fullAddress : livestream_link;

      const url = new URL(path);

      url.searchParams.append('action', 'TEMPLATE');
      url.searchParams.append('text', title);
      if (start_at && end_at) {
        url.searchParams.append('dates', `${startDate}/${endDate}`);
      }
      url.searchParams.append('details', description);
      url.searchParams.append('location', location);
      url.searchParams.append('ctz', timezone);

      const href = url.toString();
      return {
        href,
        link: null,
      };
    },
  },
  apple: {
    icon: <CalendarAppleIcon />,
    route: (event) => ({ href: routes.eventIcs(event.id).link }),
  },
  outlook: {
    icon: <OutlookIcon />,
    route: (event) => ({ href: routes.eventIcs(event.id).link }),
  },
};

export default addToCalendarData;
